import PageHeader from "@/components/PageHeader";
import { Mail, MessageCircle, Clock, Globe2, Phone } from "lucide-react";
import { WHATSAPP_URL, WHATSAPP_KATIA, WHATSAPP_GERARDO, CONTACT_EMAIL } from "@/lib/brand";

const Contacto = () => {
  return (
    <div data-testid="contacto-page">
      <PageHeader
        eyebrow="07 · Contacto"
        title="Estamos para acompañarte."
        subtitle="Escríbenos por WhatsApp o correo, y coordinamos tu primera sesión. Atención de lunes a viernes, 5 a 9 pm (hora Ciudad de México)."
      />

      <section className="px-6 md:px-14 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
          <InfoBlock
            Icon={Clock}
            title="Horario"
            body="Lunes a viernes · 5 : 00 · 9 : 00 pm (CDMX)"
          />
          <InfoBlock
            Icon={Globe2}
            title="Modalidad"
            body="Sesiones 100 % en línea vía videollamada segura."
          />
          <InfoBlock Icon={Mail} title="Correo" body={CONTACT_EMAIL} link={`mailto:${CONTACT_EMAIL}`} />
          <div
            data-testid="telefonos-block"
            className="card-soft p-6 block"
            style={{ background: "#fbf6ec" }}
          >
            <div className="flex items-start gap-3">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
                style={{
                  background: "rgba(74,21,33,0.06)",
                  color: "var(--p-burgundy)",
                }}
              >
                <Phone size={18} strokeWidth={1.4} />
              </div>
              <div>
                <div className="eyebrow" style={{ color: "var(--p-burgundy)" }}>
                  Teléfonos de contacto
                </div>
                <a
                  href={WHATSAPP_KATIA}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="tel-1"
                  className="block mt-1"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontSize: "1.05rem",
                    color: "var(--p-black)",
                  }}
                >
                  +52 729 567 0431
                </a>
                <a
                  href={WHATSAPP_GERARDO}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="tel-2"
                  className="block"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontSize: "1.05rem",
                    color: "var(--p-black)",
                  }}
                >
                  +52 55 4484 2443
                </a>
              </div>
            </div>
          </div>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-cta"
            className="block card-soft p-6"
            style={{
              background: "var(--p-burgundy)",
              color: "var(--p-cream)",
              borderColor: "transparent",
            }}
          >
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center"
                style={{ background: "rgba(255,255,255,0.1)" }}
              >
                <MessageCircle size={18} />
              </div>
              <div>
                <div className="eyebrow" style={{ color: "var(--p-gold-soft)" }}>
                  WhatsApp
                </div>
                <div
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontSize: "1.15rem",
                  }}
                >
                  Envíanos un mensaje directo
                </div>
              </div>
            </div>
          </a>
        </div>

        <p
          className="mt-10 max-w-3xl"
          style={{
            fontFamily: "Cormorant Garamond, serif",
            color: "var(--p-brown)",
            fontSize: "1.05rem",
            lineHeight: 1.6,
          }}
        >
          Si prefieres compartirnos primero un poco de tu situación, puedes
          llenar nuestro{" "}
          <a
            href="/cuestionario"
            style={{ color: "var(--p-burgundy)", textDecoration: "underline" }}
          >
            cuestionario previo
          </a>
          . Es breve, confidencial y nos permite orientarte con mayor precisión.
        </p>
      </section>
    </div>
  );
};

const InfoBlock = ({ Icon, title, body, link }) => {
  const Wrap = link ? "a" : "div";
  const wrapProps = link ? { href: link } : {};
  return (
    <Wrap
      {...wrapProps}
      className="card-soft p-6 block"
      style={{ background: "#fbf6ec" }}
    >
      <div className="flex items-center gap-3">
        <div
          className="w-10 h-10 rounded-full flex items-center justify-center"
          style={{
            background: "rgba(74,21,33,0.06)",
            color: "var(--p-burgundy)",
          }}
        >
          <Icon size={18} strokeWidth={1.4} />
        </div>
        <div>
          <div className="eyebrow" style={{ color: "var(--p-burgundy)" }}>
            {title}
          </div>
          <div
            style={{
              fontFamily: "Cormorant Garamond, serif",
              fontSize: "1.05rem",
              color: "var(--p-black)",
            }}
          >
            {body}
          </div>
        </div>
      </div>
    </Wrap>
  );
};

export default Contacto;
